import React, { useLayoutEffect, useRef } from 'react';
import { styled } from '@compiled/react';

/**
 * Small wrapper around a hidden file input. Allows for declarative consumption.
 *
 * TODO CHOOK-336 Remove this component in favour of Browser from
 * atlaskit/media-ui once Insight supports media-services containers
 */
export const FileBrowser = ({
	isOpen,
	onClose,
	onReceiveFiles,
	accept,
	multiple,
	testId,
	ariaLabel,
}: {
	isOpen: boolean;
	onClose: () => void;
	onReceiveFiles: (arg1: File[]) => undefined | Promise<void>;
	accept?: string;
	multiple: boolean;
	testId?: string;
	ariaLabel?: string;
}) => {
	const inputRef = useRef<HTMLInputElement>(null);

	useLayoutEffect(() => {
		if (isOpen) {
			if (inputRef.current) {
				// Click the input to open the file browser
				inputRef.current.click();
			}

			// No browser API to know when file upload is closed, so we call
			// onClose immediately after opening
			onClose();
		}
	}, [isOpen, onClose]);

	return (
		<HiddenInput
			type="file"
			ref={inputRef}
			multiple={multiple}
			accept={accept}
			onChange={(event) => {
				onReceiveFiles(Array.from(event.target.files ?? []));
				// Reset file input after sending file to parent
				const inputEl = event.target;
				inputEl.value = '';
			}}
			data-testId={testId}
			aria-label={ariaLabel}
		/>
	);
};

FileBrowser.defaultProps = {
	multiple: true,
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const HiddenInput = styled.input({
	visibility: 'hidden',
	position: 'absolute',
	zIndex: -1,
});
